module.exports = __webpack_public_path__ + "img/intro_5.8cbd09f.png";